import types from '../../constants';
import auth from '../../auth';

export default {
  changeUser: function (event) {
    return (dispatch) => {
      dispatch({
        type: types.LOGIN_CHANGE_USER,
        payload: event.target.value,
      });
    };
  },

  changePassword: function (event) {
    return (dispatch) => {
      dispatch({
        type: types.LOGIN_CHANGE_PASSWORD,
        payload: event.target.value,
      });
    };
  },

  goRestore: function () {
    return (dispatch) => {
      dispatch({type: types.LOGIN_GO_RESTORE});
    };
  },

  goLogin: function () {
    return (dispatch) => {
      dispatch({type: types.LOGIN_GO_LOGIN});
    };
  },

  fetchCurUser: function () {
    return (dispatch) => {
      fetch('/api/users/curuser', {
        headers: {
          pragma: 'no-cache',
          Accept: 'application/json',
          Authorization: localStorage.token,
        },
      })
        .then(response => response.json())
        .then(data => {
          auth.updateUserData(data);
          dispatch({type: types.LOGIN_USER_FETCH, payload: data.user});
        });
    };
  },

  setCurUser: function (user) {
    return (dispatch) => {
      dispatch({type: types.LOGIN_USER_FETCH, payload: user});
    }
  },

  login: function (user, password, e) {
    e.preventDefault();

    return (dispatch) => {
      dispatch({type: types.LOGIN_LOADING});

      user = user.toLowerCase().replace(/ /g, '');

      fetch('/api/login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({user, password}),
      })
        .then(response => response.json())
        .then((data) => {
          if (data.blockedUntil) {
            const {
              value,
              unit,
            } = data.blockedUntil;

            return dispatch({
              type: types.LOGIN_FAILED,
              payload: `Too many wrong attempts. Wait for ${value} ${unit} and try again.`,
            });
          }

          if (data.error) {
            return dispatch({
              type: types.LOGIN_FAILED,
              payload: data.error,
            });
          }
          return auth.login(data, () => {
            dispatch({type: types.LOGIN_SUCCESS, payload: data.user});

            // history.push('/');
            window.location.href = '/';
          });
        }).catch((Z) => (
        dispatch({
          type: types.LOGIN_FAILED,
          payload: 'An internal error has eccured.',
        })
      ));
    };
  },

  restorePassword: function (user, e) {
    e.preventDefault();

    return (dispatch) => {
      fetch('/api/login/restore/create-approve', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({user}),
      })
        .then(response => response.json())
        .then((data) => {

          if (data.error) {
            return dispatch({
              type: types.LOGIN_FAILED,
              payload: data.error,
            });
          }
          {

            return dispatch({
              type: types.RESTORE_SENT,
            });
          }
        })
        .catch((Z) => (
          dispatch({
            type: types.LOGIN_FAILED,
            payload: 'No record for that user email address found. Please visit https://simsushare.com or email support@simsushare.com for assistance.',
          })
        ))
    }
  },

  getRestorePswdApprove: function (token) {
    return (dispatch) => {
      dispatch({type: types.LOGIN_LOADING});
      fetch('/api/login/restore/get-approve/' + token)
        .then(response => response.json())
        .then((data) => {
          if (data.error) {
            return dispatch({
              type: types.LOGIN_FAILED,
              payload: data.error,
            });
          }
          {
            return dispatch({
              type: types.RESTORE_GET_APPROVE,
              payload: data._id
            });
          }
        });
    }
  },

  setPassword: function (userId, password, token, e) {
    e.preventDefault();
    return (dispatch) => {
      fetch('/api/login/restore/set-password/' + token, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({password}),
      })
        .then(response => response.json())
        .then((data) => {

          if (data.error) {
            if (typeof data.error === 'object') {
              Object.keys(data.error).map(key => {
                return dispatch({
                  type: types.LOGIN_FAILED,
                  payload: key + ': ' + data.error[key],
                });
              })
            }
            else {
              return dispatch({
                type: types.LOGIN_FAILED,
                payload: data.error,
              });
            }
          }
          else {
            return dispatch({
              type: types.RESTORE_SENT,
            });
          }
        })
        .catch((Z) => (
          dispatch({
            type: types.LOGIN_FAILED,
            payload: 'An internal error has occured.',
          })
        ))
    }
  }
}
